import * as React from "react";

type RotateLoadingIconVariant = 'gradient' | 'white'

interface RotateLoadingIconProps extends React.SVGProps<SVGSVGElement> {
  variant?: RotateLoadingIconVariant
}

const GRADIENT_ID = "paint0_linear_8929_13842"

const PATH = "M22 12C22 14.0842 21.3488 16.1162 20.1374 17.8122C18.9261 19.5082 17.2151 20.7833 15.2436 21.4593C13.2721 22.1354 11.1387 22.1785 9.14152 21.5827C7.14432 20.987 5.38317 19.7821 4.10422 18.1365C2.82528 16.4909 2.09245 14.4868 2.00818 12.4043C1.92391 10.3219 2.4924 8.26514 3.63419 6.52157C4.77598 4.778 6.43401 3.43475 8.37654 2.67956C10.3191 1.92438 12.449 1.795 14.4687 2.30951L14.0506 3.95053C12.373 3.52315 10.6037 3.63062 8.99015 4.25792C7.37658 4.88522 5.99932 6.001 5.05088 7.44931C4.10244 8.89761 3.63023 10.6061 3.70023 12.3359C3.77023 14.0657 4.37895 15.7304 5.44132 17.0973C6.50368 18.4643 7.96659 19.4651 9.62558 19.96C11.2846 20.4548 13.0567 20.419 14.6943 19.8575C16.332 19.2959 17.7532 18.2367 18.7594 16.828C19.7657 15.4192 20.3066 13.7312 20.3066 12H22Z"

const RotateLoadingIcon = ({ variant = 'gradient', ...props }: RotateLoadingIconProps) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <style>
      {`
        @keyframes rotate {
          100% {
            transform: rotate(360deg);
          }
        }
      `}
    </style>
    <g style={{ animation: "rotate 1s linear infinite", transformOrigin: "12px 12px" }}>
      <path
        d={PATH}
        fill={variant === 'white' ? 'white' : `url(#${GRADIENT_ID})`}
      />
    </g>
    {variant !== 'white' && (
      <defs>
        <linearGradient
          id={GRADIENT_ID}
          x1={2}
          y1={12}
          x2={22}
          y2={12}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#02FCFF" />
          <stop offset={1} stopColor="#FC00FF" />
        </linearGradient>
      </defs>
    )}
  </svg>
)

export default RotateLoadingIcon;
